// extracted by mini-css-extract-plugin
module.exports = {"header":"S_bc","root":"S_cx","backTo":"S_d7","date":"S_t","markdownStyles":"S_d8"};